import { render } from "./PosterCard.vue?vue&type=template&id=733f8de5&ts=true"
import script from "./PosterCard.vue?vue&type=script&lang=ts"
export * from "./PosterCard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__